import * as Yup from "yup";
import { FormGroup } from "../../../components/form";

export const applicationOutcomeForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory1",
      fieldType: "advisory",
      props: {
        type: "warning",
        Body: () => (
          <p>
            Select the required option to send an email to the kindergarten providing information about the outcome of their application or appeal.
            Emails relating to checklist outcomes must be generated from the <strong>Application Checklist</strong> section of the application.
          </p>
        ),
      },
    },
    {
      type: "field",
      key: "advisory2",
      fieldType: "advisory",
      props: {
        type: "sectionHeader",
      },
      label: "Type of Email",
    },
    {
      type: "field",
      fieldType: "radio",
      key: "typeOfEmail",
      label: "Select the type of email to send",
      validation: Yup.number().required("A response is required"),
      props: {
        isRequired: true,
        options: [
          {
            label: "Application is being closed or withdrawn",
            value: 0,
          },
          {
            label: "Application or appeal assessment is complete and ready for the outcome to be sent",
            value: 1,
          },
        ],
      },
    },
    {
      type: "formGroup",
      key: "applicationClosedOrWithdrawn",
      hideExpression: (context, values, model) => model.typeOfEmail != 0,
      fields: [
        {
          type: "field",
          key: "advisory3",
          fieldType: "advisory",
          props: {
            type: "sectionHeader",
          },
          label: "Application Closure",
        },
        {
          type: "field",
          fieldType: "radio",
          key: "typeOfClosure",
          label: "Select type of application closure",
          validation: Yup.number().required("A response is required"),
          props: {
            isRequired: true,
            options: [
              {
                label: "Closed - additional information not provided",
                value: 0,
                extendedlabel:
                  "Use this option where the kindergarten has failed to provide requested information and the application has been closed",
              },
              {
                label: "Withdrawn",
                value: 1,
                extendedlabel: "Use this option where the kindergarten has advised that they wish to withdraw the application",
              },
            ],
          },
        },
        {
          type: "field",
          fieldType: "textarea",
          key: "reasonForWithdrawal",
          label: "Reason for application withdrawal",
          hideExpression: (context, values, model) => model.typeOfClosure != 1,
          validation: Yup.string().trim().required("A response is required"),
          props: {
            isRequired: true,
          },
        },
      ],
    },
    {
      type: "formGroup",
      key: "applicationOutcome",
      hideExpression: (context, values, model) => context.isAppeal || model.typeOfEmail != 1 || context.isApplicationEligible == null,
      fields: [
        {
          type: "field",
          key: "advisory4",
          fieldType: "advisory",
          props: {
            type: "sectionHeader",
          },
          label: "Application Outcome",
        },
        {
          type: "field",
          fieldType: "radio",
          key: "applicationEligible",
          label: "Application Outcome",
          validation: Yup.number().required("A response is required"),
          props: {
            isRequired: true,
            options: [
              {
                label: "Eligible",
                value: 1,
                hideExpression: (context: any) => context.isApplicationEligible !== "Yes",
              },
              {
                label: "Ineligible",
                value: 2,
                hideExpression: (context: any) => context.isApplicationEligible !== "No",
              },
            ],
          },
        },
      ],
    },
    {
      type: "formGroup",
      key: "appealOutcome",
      hideExpression: (context, values, model) => !context.isAppeal || model.typeOfEmail != 1,
      fields: [
        {
          type: "field",
          key: "advisory5",
          fieldType: "advisory",
          props: {
            type: "sectionHeader",
          },
          label: "Appeal Outcome",
        },
        {
          type: "field",
          fieldType: "radio",
          key: "appealEligible",
          label: "Select Appeal Outcome",
          validation: Yup.number().required("A response is required"),
          props: {
            isRequired: true,
            options: [
              {
                label: "Increase or addition of support",
                value: 0,
              },
              {
                label: "Maintained",
                value: 1,
              },
              {
                label: "Ineligible",
                value: 2,
              },
              {
                label: "Was ineligible but is now eligible",
                value: 3,
              },
            ],
          },
        },
      ],
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "additionalComments",
      label: "Additional Comments",
      hideExpression: (context, values, model) => model.typeOfEmail == null,
      props: {
        warn: "This will be provided to the kindergarten",
      },
    },
  ],
};
